import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import TrustBar from "@/components/sections/TrustBar";
import Services from "@/components/sections/Services";
import Features from "@/components/sections/Features";
import Portfolio from "@/components/sections/Portfolio";
import ContactCards from "@/components/sections/ContactCards";
import ContactForm from "@/components/sections/ContactForm";
import SupportTeam from "@/components/sections/SupportTeam";
import Footer from "@/components/sections/Footer";

const TOAST_STYLE = {
  background: "#ffffff",
  border: "1px solid rgba(0, 102, 255, 0.22)",
  color: "#0a0e1a",
  boxShadow: "0 18px 50px -20px rgba(10,15,30,0.18)",
};

function useScrollReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in-view");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}

export default function App() {
  useScrollReveal();

  return (
    <div className="App relative bg-white text-[#0a0e1a]" data-testid="arj-landing-root">
      <Toaster position="top-center" theme="light" toastOptions={{ style: TOAST_STYLE }} />
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <Services />
        <Features />
        <Portfolio />
        <ContactCards />
        <ContactForm />
        <SupportTeam />
      </main>
      <Footer />
    </div>
  );
}
